import { PdfDialog } from './pdf/PdfDialog';
import { ShapefileDialog } from './shapefile/ShapefileDialog';
import { FourRDialog } from './fourR/FourRDialog';
import { DeleteDialog } from './delete/DeleteDialog';
import { RenameDialog } from './rename/RenameDialog';

export function ActionDialogs(props) {
  return (
    <>
      <RenameDialog />
      <DeleteDialog />
      <PdfDialog />
      <ShapefileDialog />
      <FourRDialog />
      {props.children}
    </>
  );
}
